export const REGXURL = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';

// LOCALHOST
export const OLDLOCALHOSTCLIENTID = 'abd21e64-2970-4cc9-8b0b-0c8b7e93ddfb';
export const LOCALHOSTCLIENTID = 'f78d660e-59ae-490d-bfd4-f6b8e1f4f5f5';
// DEV
export const OLDURLDEV = 'https://skynet-api-dev.azure-api.net';
export const OLDCLIENTIDDEV = 'ca2c2c29-7fa5-4edf-a906-f601dc52148c';
export const OLDTENANTIDDEV = '76e5b2b1-232f-4f31-bdea-ef1a2bd02ec3';
export const OLDSTORAGEDEV = 'stnitbackofficedev';
export const URLDEV = 'https://dev.api-digital.alicorp.com.pe';
export const APISUBSCRIPTIONDEV = '7f51ccfb0a2e421f8080dd80531313e0';
export const CLIENTIDDEV = 'fa294d47-4abb-4f66-9577-3025519bd6b4';
export const TENANTIDDEV = '3b16616d-f174-497a-a1ae-900d85106996';
export const STORAGEDEV = 'alieus2stadgtnitdev01';
export const PASSVERIFYDEV = 'Alicorp2023?';
export const USERVERIFYDEV = 'NITROBOQA';
export const URLDEVVERIFY = 'https://ali-apim-dgt-dev-fgf4ekg0g6fqg4c3.a03.azurefd.net';
export const ENCRIPTIONPUBLICKEYDEV = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlAU+0+wtg1UJWNtIBl40
x2TIyr6bPS2n2vk/ZB7fFIZF7ogDg3gwzYujCxO0+RKJxSWFReOo+BA3MBjkVBEC
NOJHjgP1AjKK3pwJ5GZaUlpAMP1tJaS0JWTIkCmsc/l8TTLdK40SN1oRHROTj3WO
5XTQe6XCfq2Pr4KusX6CE+M1ZKdI3NihxE7sTDfsD114EKxYhH6f7f2+/g67cSGb
bXNTZeqeI6wRIJoQpyuVNQxgpD5G6z966Ejb7Y61B8qnmYopnjkoafQ4swjLdVnx
HgU+qtX85pXhGP6CqU1NEDndSlQnTRxzCinIkzkK2/ma4wrgL6SK6T0Qcki+xJue
9wIDAQAB
-----END PUBLIC KEY-----`;
// QA
export const OLDURLQA = 'https://skynet-api-qa.azure-api.net';
export const OLDCLIENTIDQA = '49c7a711-8392-48af-9b6e-ce3a1b22e460';
export const OLDTENANTIDQA = '76e5b2b1-232f-4f31-bdea-ef1a2bd02ec3';
export const OLDSTORAGEQA = 'stnitbackofficeqa';
export const OLDAPISUBSCRIPTIONQA = '4f45e49c5e2744b69ccf18acb2b7c154';
export const URLQA = 'https://qa.api-digital.alicorp.com.pe';
export const APISUBSCRIPTIONQA = 'ae536d51e95a478d90709f2f3bcdd68d';
export const CLIENTIDQA = 'eaa202c2-3ccf-4d32-b1f2-86a4240d798c';
export const TENANTIDQA = '3b16616d-f174-497a-a1ae-900d85106996';
export const STORAGEQA = 'alieus2stadgtnitpre01';
export const PASSVERIFYQA = 'Alicorp2023?';
export const USERVERIFYQA = 'NITROBOQA';
export const URLQAVERIFY = 'https://ali-eus2-apim-cn-dgt-pre-fde4e0fmb8a8gbc8.a03.azurefd.net';
export const ENCRIPTIONPUBLICKEYQA = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlAU+0+wtg1UJWNtIBl40
x2TIyr6bPS2n2vk/ZB7fFIZF7ogDg3gwzYujCxO0+RKJxSWFReOo+BA3MBjkVBEC
NOJHjgP1AjKK3pwJ5GZaUlpAMP1tJaS0JWTIkCmsc/l8TTLdK40SN1oRHROTj3WO
5XTQe6XCfq2Pr4KusX6CE+M1ZKdI3NihxE7sTDfsD114EKxYhH6f7f2+/g67cSGb
bXNTZeqeI6wRIJoQpyuVNQxgpD5G6z966Ejb7Y61B8qnmYopnjkoafQ4swjLdVnx
HgU+qtX85pXhGP6CqU1NEDndSlQnTRxzCinIkzkK2/ma4wrgL6SK6T0Qcki+xJue
9wIDAQAB
-----END PUBLIC KEY-----`;

// PROD
export const OLDURLPROD = 'https://skynet-api.azure-api.net';
export const OLDCLIENTIDPROD = '8c53c3a9-6a35-45fe-9af8-b896dcbe284a';
export const OLDTENANTIDPROD = '76e5b2b1-232f-4f31-bdea-ef1a2bd02ec3';
export const OLDSTORAGEPROD = 'stnitbackoffice';
export const OLDAPISUBSCRIPTIONPROD = '047d8a881de444efb01dc6e9fb0fa8c5';
export const URLPROD = 'https://api-digital.alicorp.com.pe';
export const APISUBSCRIPTIONPROD = '047d8a881de444efb01dc6e9fb0fa8c5';
export const CLIENTIDPROD = 'aeec00e1-a19f-4493-a582-96dc05737dd2';
export const TENANTIDPROD = '3b16616d-f174-497a-a1ae-900d85106996';
export const STORAGEPROD = 'alieus2stadgtnitprod01';
export const PASSVERIFYPROD = 'Alicorp2023?';
export const USERVERIFYPROD = 'NITROBOPROD';
export const URLPRODVERIFY = 'https://ali-eus2-apim-cn-dgt-pre-fde4e0fmb8a8gbc8.a03.azurefd.net';
export const ENCRIPTIONPUBLICKEYPROD = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlAU+0+wtg1UJWNtIBl40
x2TIyr6bPS2n2vk/ZB7fFIZF7ogDg3gwzYujCxO0+RKJxSWFReOo+BA3MBjkVBEC
NOJHjgP1AjKK3pwJ5GZaUlpAMP1tJaS0JWTIkCmsc/l8TTLdK40SN1oRHROTj3WO
5XTQe6XCfq2Pr4KusX6CE+M1ZKdI3NihxE7sTDfsD114EKxYhH6f7f2+/g67cSGb
bXNTZeqeI6wRIJoQpyuVNQxgpD5G6z966Ejb7Y61B8qnmYopnjkoafQ4swjLdVnx
HgU+qtX85pXhGP6CqU1NEDndSlQnTRxzCinIkzkK2/ma4wrgL6SK6T0Qcki+xJue
9wIDAQAB
-----END PUBLIC KEY-----`;
